import type { FC } from 'react';
import { useDeposit } from '@mwl/core-lib';
import { PaymentFormHeader } from '../../../../components/PaymentFormHeader/PaymentFormHeader';
import type { DepositFormIframeProps } from './DepositFormIframe.types';
import styles from './DepositFormIframe.module.scss';
export const DepositFormIframe: FC<DepositFormIframeProps> = ({
  onClose
}) => {
  const {
    content: {
      iframeUrl
    }
  } = useDeposit();
  return <div className={styles.root} data-sentry-component="DepositFormIframe" data-sentry-source-file="DepositFormIframe.tsx">
      <PaymentFormHeader onClose={onClose} data-sentry-element="PaymentFormHeader" data-sentry-source-file="DepositFormIframe.tsx" />
      <div className={styles.frameWrapper}>
        <iframe src={iframeUrl} title={iframeUrl} />
      </div>
    </div>;
};